"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveySchema = void 0;
const azavista_types_1 = require("@azavista/azavista-types");
exports.SurveySchema = {
  type: 'object',
  required: ['form_ids', 'thank_you_page_id'],
  additionalProperties: false,
  properties: {
    count_as: {
      type: 'string',
      enum: [''].concat(Object.values(azavista_types_1.CrmStatus))
    },
    form_ids: {
      type: 'array',
      minItems: 1,
      items: {
        type: 'string'
      }
    },
    page_ids: {
      type: 'array',
      items: {
        type: 'string'
      }
    },
    email_campaign_id: {
      type: ['string', 'null']
    },
    thank_you_page_id: {
      type: ['string', 'null']
    },
    cancellation_workflow_id: {
      type: ['string', 'null']
    },
    survey_pending_stage_name: {
      type: 'string'
    },
    survey_completed_stage_name: {
      type: 'string'
    },
    next_workflow_ids: {
      type: 'object',
      properties: {
        next_workflow: {
          type: ['string', 'null']
        }
      }
    }
  }
};
